import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { ColumnAnalysisRequest, ColumnAnalysisResponse } from './types';

export function useColumnAnalysisQuery(req: ColumnAnalysisRequest) {
  const [debounced, setDebounced] = useState(req);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(req), 300);
    return () => window.clearTimeout(t);
  }, [req]);
  return useQuery<ColumnAnalysisResponse>({
    queryKey: ['analysis', 'columns', debounced],
    queryFn: async () => (await api.post('/api/analysis/columns', debounced)).data,
    placeholderData: (prev) => prev,
    retry: false,
    staleTime: 60_000,
  });
}
